import React from 'react';

/**
 * An editor's local value that follows its prop only when the prop's value changes. A re-render that brings the same
 * value (a refreshed row whose other fields changed) keeps whatever the teacher has typed but not saved yet.
 */
export function useSyncedState<T>(value: T): [T, React.Dispatch<React.SetStateAction<T>>] {
    const [state, setState] = React.useState(value);
    const last = React.useRef(JSON.stringify(value ?? null));
    React.useEffect(() => {
        const next = JSON.stringify(value ?? null);
        if (next === last.current) return;
        last.current = next;
        setState(value);
    }, [value]);
    return [state, setState];
}
